export const seo = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  publishedTime,
  modifiedTime,
}: {
  title?: string;
  description?: string;
  image?: string;
  keywords?: string;
  url?: string;
  /** `article` for blog posts: aggregators and social cards treat them differently from a page. */
  type?: 'website' | 'article';
  /** ISO 8601; only meaningful with type: 'article'. */
  publishedTime?: string;
  modifiedTime?: string;
}) => {
  const tags = [
    { title },
    { name: 'description', content: description },
    { name: 'keywords', content: keywords },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:creator', content: '@teamplay' },
    { name: 'twitter:site', content: '@teamplay' },
    // Open Graph uses the `property` attribute per spec (Facebook/LinkedIn read
    // property, not name); Twitter cards correctly stay on `name`.
    { property: 'og:type', content: type },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:url', content: url },
    // article:* принадлежит типу article — на website-странице эти поля просто мусор в разметке.
    ...(type === 'article' && publishedTime
      ? [{ property: 'article:published_time', content: publishedTime }]
      : []),
    ...(type === 'article' && modifiedTime
      ? [{ property: 'article:modified_time', content: modifiedTime }]
      : []),
    ...(image
      ? [
          { name: 'twitter:image', content: image },
          { name: 'twitter:card', content: 'summary_large_image' },
          { property: 'og:image', content: image },
        ]
      : []),
  ];

  return tags;
};
